"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _getCountryOptions = require("../internal/utils/getCountryOptions");

var CountrySelect = function CountrySelect(props) {
  var className = props.className,
      validCountries = props.validCountries,
      optionsFilter = props.optionsFilter,
      passThroughProps = (0, _objectWithoutProperties2.default)(props, ["className", "validCountries", "optionsFilter"]);
  return _react.default.createElement(_UISelect.default, (0, _extends2.default)({}, passThroughProps, {
    className: (0, _classNames.default)('country-select-input', className),
    options: validCountries ? (0, _getCountryOptions.getOptionsForValidCountries)({
      validCountries: validCountries,
      optionsFilter: optionsFilter
    }) : (0, _getCountryOptions.getCountryOptions)({
      optionsFilter: optionsFilter
    })
  }));
};

CountrySelect.propTypes = {
  className: _react.PropTypes.string,
  optionsFilter: _react.PropTypes.func,
  validCountries: _react.PropTypes.array
};
var _default = CountrySelect;
exports.default = _default;
module.exports = exports.default;